import axios from "const/axios";
import { API_URL } from "const/constants";

const base = `${API_URL}/accounts/other-entries`;

/** Raise a custom charge on a client. Returns the created entry's summary. */
export async function createOtherEntry(clientId, entry) {
  const { data } = await axios.post(`${base}/clients/${clientId}`, entry);
  return data?.data ?? null;
}

export async function updateOtherEntry(cadId, entry) {
  const { data } = await axios.put(`${base}/${cadId}`, entry);
  return data?.data ?? null;
}

export async function fetchOtherEntryDocuments(cadId) {
  if (!cadId) return [];
  const { data } = await axios.get(`${base}/${cadId}/documents`);
  return data?.data ?? [];
}

/** Replaces the whole list, which is how the module screens already treat their documents. */
export async function saveOtherEntryDocuments(cadId, documents) {
  const { data } = await axios.put(`${base}/${cadId}/documents`, {
    documents: (documents || []).map(({ id, name, url }) => ({ id, name, url })),
  });
  return data?.data ?? [];
}

export async function fetchOtherEntryDeletePreview(cadId) {
  if (!cadId) return null;
  const { data } = await axios.get(`${base}/${cadId}/delete-preview`);
  return data?.data ?? null;
}

export async function deleteOtherEntry(cadId) {
  const { data } = await axios.delete(`${base}/${cadId}`);
  return data;
}
